import { Directive, effect, inject, input, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserAccessService } from '../service/user-access/user-access.service';

/**
 * Directive to show or hide an element based on the current user's permissions to access a certain path.
 * For configuration of permissions and paths see UserAccessService and `route-permissions.config.ts`.
 * Usage:
 * ```html
 * <div *ikpIfHasPermissionForPath="'some/restricted/path'">This is only visible if the path is accessible for the user</div>
 * ```
 */
@Directive({
  selector: '[ikpIfHasPermissionForPath]',
  standalone: true,
})
export class PathAccessPermissionsDirective {
  private userAccessService = inject(UserAccessService);
  private templateRef: TemplateRef<unknown> = inject(TemplateRef);
  private viewContainer: ViewContainerRef = inject(ViewContainerRef);

  ikpIfHasPermissionForPath = input.required<string>();

  private changeElementVisibility = effect(() => {
    const hasAccess = this.userAccessService.hasUserAccessAsSignal(this.ikpIfHasPermissionForPath());
    if (hasAccess()) {
      this.viewContainer.clear();
      const element = this.viewContainer.createEmbeddedView(this.templateRef);
      element.detectChanges();
    } else {
      this.viewContainer.clear();
    }
  });
}
